import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewRequest from "@/pages/NewRequest";
import Queue from "@/pages/Queue";
import RequestDetail from "@/pages/RequestDetail";
import Reports from "@/pages/Reports";
import Accounting from "@/pages/Accounting";
import AuditLog from "@/pages/AuditLog";
import Admin from "@/pages/Admin";
import Setup2FA from "@/pages/Setup2FA";

function Protected({ children }) {
  const { user, settings } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Enforce mandatory 2FA setup
  if (settings?.totp_enforced && !user.totp_enabled) {
    return <Navigate to="/setup-2fa" replace />;
  }
  return children;
}

function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Setup2FAGate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.totp_enabled) return <Navigate to="/" replace />;
  return <Setup2FA />;
}

function AppRoutes() {  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/setup-2fa" element={<Setup2FAGate />} />
      <Route path="/" element={<Protected><AppShell /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="new" element={<RoleGuard roles={["admin","requester"]}><NewRequest /></RoleGuard>} />
        <Route path="queue" element={<Queue />} />
        <Route path="requests/:id" element={<RequestDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="accounting" element={<RoleGuard roles={["admin","auditor","requester"]}><Accounting /></RoleGuard>} />
        <Route path="audit-log" element={<RoleGuard roles={["admin","auditor","requester"]}><AuditLog /></RoleGuard>} />
        <Route path="admin" element={<RoleGuard roles={["admin","requester"]}><Admin /></RoleGuard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
